<template>
  <v-dialog 
  v-model="dialog" 
  content-class="c-dialog-border-13"
  scrollable 
  persistent 
  transition="c-anim-slide-left-fade"
  :fullscreen="$vuetify.breakpoint.xs" 
  max-width="400px">

  <v-card>

    <v-layout align-center class="c-flex-00a crx-toolbar">
      <v-btn
      icon
      text
      @click="dialog = false">
        <v-icon color="color1">mdi-close</v-icon>
      </v-btn>
      <div class="c-flex-r1 align-center justify-center subheading font-weight-bold">
        {{ id ? 'Edit' : 'New internal code' }}
      </div>
      <v-btn
      icon
      text
      rounded @click.native="confirm"
      :loading="loading">
        <v-icon color="color1">mdi-check</v-icon>
      </v-btn>
    </v-layout>
    
    <!-- DIALOG MAIN CONTENT -->
    <div style="overflow: auto;" class="pa-3">

      <div class="c-flex-c1">
      <img style="align-self: center;" src="@/assets/img/illustrations/sugar-and-cinnamon.png" alt="cardboard box" width="80px">

        <div class="font-weight-medium grey--text">
          Internal code
        </div>
        <c-input class="crx-box-input" :value.sync="code"></c-input>

        <div class="font-weight-medium mt-4 grey--text">
          Item
        </div>

        <v-layout 
        @click="selectOutput"
        class="crx-box-input pa-2" align-center>
          <template v-if="!definition">
            Select...
          </template>
          <template v-else>
            <div class="">
              {{ definition.name }}
            </div>
          </template>
          <v-spacer></v-spacer>
          <v-icon>mdi-menu-down</v-icon>
        </v-layout>

        <div class="font-weight-medium mt-4 grey--text">
          Supplier
        </div>

        <c-select-supplier :selectedID.sync="supplier" class="crx-box-input">
        </c-select-supplier>

        <div class="font-weight-medium mt-4 grey--text">
          Producer
        </div>
        <c-input class="crx-box-input" :value.sync="producer"></c-input>
        
      </div>
    </div><!-- END DIALOG MAIN CONTENT -->
    </v-card>

    <c-select-inv-def-dialog ref="selectItemDialog">
    </c-select-inv-def-dialog>

  </v-dialog>
</template>

<script>

export default {
  data () {
    return {
      dialog: false,
      id: null,
      code: '',
      inventory_item_id: null,
      supplier: null,
      producer: '',
      definition: {},
      error: '',
      loading: false
    }
  },
  methods: {
    new (_presets) {
      this.id = null
      var presets = _presets || {}
      if (presets) {
        this.code = presets.code || ''
        this.supplier = presets.supplier || null
        this.inventory_item_id = presets.inventory_item_id || null
        this.producer = presets.producer || ''
        this.definition = presets.definition || {}
      }
      this.dialog = true
    },
    edit (item) {
      this.id = item.id
      this.code = item.code
      this.inventory_item_id = item.inventory_item_id
      this.supplier = item.supplier
      this.producer = item.producer
      this.definition = item.definition
      this.dialog = true
    },
    confirm () {
      if (this.id !== null) {
        this.updateItem()
      } else {
        this.createItem()
      }
    },
    selectOutput () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.inventory_item_id = selectedItem.id
          this.definition = selectedItem
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    createItem () {
      this.loading = true
      this.error = ''
      this.$axios.post('internal-codes/new',
        {
          code: this.code,
          inventory_item_id: this.inventory_item_id,
          supplier: this.supplier,
          producer: this.producer
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.dialog = false
            this.$emit('onUpdate')
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.loading = false
        })
        // */
    },
    updateItem () {
      this.loading = true
      this.error = ''
      this.$axios.patch('internal-codes/' + this.id,
        {
          code: this.code,
          inventory_item_id: this.inventory_item_id,
          supplier: this.supplier,
          producer: this.producer
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            console.log(response)
            this.dialog = false
            this.$emit('onUpdate')
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.loading = false
        })
        // */
    }
  }
}
</script>

<style scoped>

</style>
